module.exports = __webpack_public_path__ + "img/logo-min.3ff7c755.png";